export const farmingStartTime = 1635451200;
export const eps = BigInt('1584436925410000000');
export const oneYear = BigInt('31556952');
export const oneDay = BigInt(24 * 60 * 60);
